import type { RemoveGroup } from './types.js';
import { locateProxy } from '#~/agent/index.js';
import { StudioError } from '#~/error/index.js';

/**
 * Removes the specified device preset group.
 *
 * @param deviceId - The ID of the device to which this group belongs.
 * @param groupId - The ID of the group to be removed.
 * @param token - The token.
 */
export const removeGroup: RemoveGroup = async (deviceId, groupId, token) => {
  try {
    const proxy = locateProxy(deviceId);

    if (!proxy) {
      throw new Error('DG-244');
    }

    await proxy.mutate(
      {},
      {
        control: {
          studio: {
            device: {
              [deviceId]: {
                control: {
                  presets: {
                    groups: {
                      [groupId]: {}
                    }
                  }
                }
              }
            }
          }
        }
      }
    );

    await proxy.save(token);
  } catch (cause) {
    throw new StudioError('Unable to remove preset group.', { cause });
  }
};
